import { Component, EventEmitter, Input,  OnInit, Output, TemplateRef} from "@angular/core";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ToastrService } from "ngx-toastr";
import * as CONSTANT from "../../services/constants";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { HttpBackend, HttpClient } from "@angular/common/http"
import { ImageUrls } from "src/app/services/s3buket";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-company-profile",
  templateUrl: "./company-profile.component.html",
  styleUrls: ["./company-profile.component.css"]
})
export class CompanyProfileComponent implements OnInit {
  modalRef?: BsModalRef;
  fileUpload;
  dummyImage:any;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;
  form: FormGroup;
  showError = false;
  showErrorImage = false;
  showDiv = true;
  showEmail = false;
  loader = false;
  public loading = false; 
  countryCode =1;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  // cropper
  image;
  profileImageUpload;
  imageUpload;
  show: boolean = false;
  @Output() changeDetected: EventEmitter<any> = new EventEmitter<any>();
  @Input() objectProperty: any;
  @Output() valueChange = new EventEmitter();
  objectProp: any;
  // states
  allStates:any=[];
  allData:any;
  userData:any;
  constructor(private modalService: BsModalService,private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService,private http: HttpClient, private handler: HttpBackend, private datePipe: DatePipe) {
    this.form = this.formBuilder.group({
      profileImage: [""], 
      companyName: ["", Validators.compose([Validators.required])],
      industry: ["", Validators.compose([Validators.required])],
      companySize: [""],
      description: ["", Validators.compose([Validators.required,Validators.maxLength(250)])],
      
      companyEmail: ["", Validators.compose([Validators.pattern(CONSTANT.EMAIL_REGEX)])],
      phoneNumber: [""],
      countryCode: ["+1"], 
      linkedInLink: ["", Validators.compose([Validators.pattern(CONSTANT.URL_REGEX)])],
      websiteLink: ["", Validators.compose([Validators.pattern(CONSTANT.URL_REGEX)])],

      address: ["", Validators.compose([Validators.required])],
      state: ["", Validators.compose([Validators.required])],
      city: ["", Validators.compose([Validators.required])],
      location: ["", Validators.compose([Validators.required])],
      zipCode: ["", Validators.compose([Validators.required])],

      longitude: [""],
      latitude: [""], 
      subscribeHonorvet:[""],
    });
   }

  ngOnInit(): void {
    this.userData = localStorage.getItem("userId")
    this.getUserDetail();
    this.getState();
    
  } 
  //getUserDetail
  getUserDetail(){
    this.api.getDatas(apiUrl._getRecuriterDetail+"/"+this.userData)
    .subscribe(async (res) => {
      console.log(res,"stats");
      this.allData = res.data.Recruiter;
      this.imageUpload = res.data.Recruiter?.profileImage;
      this.form.patchValue({
        ...this.allData,
        // state:this.allData.state
      })
    })
  }
  //getState
  getState(){
    this.api.getDatas(apiUrl._stateApi)
    .subscribe(async (res) => {
      console.log(res,"stats");
      this.allStates = res.data.rows;
    })
  }
// image upload
  upload(event) { 
    if (event.target.files.length == 0) {
      return
    }
    if (event.target.files[0].type.includes("image") && event.target.files[0].name.split(".")[1] !="jfif") {
      this.show = true;
      this.loader = true;
      this.objectProp = { "event": event, "directory": "recruiter/", "imagewidthsize": false, "imageheightsize": false, "aspectRatio": 1 / 1, "roundCropper": false,"maintainAspectRatio" : true,"typeCropper": 1, "cropperHeight" : 500, "cropperMinWidth" : 500,"showOnlySquare" : true };
    } else{
      this.toastrService.error("Please upload only Jpg,Jpeg & Png images!");
      this.show = false;
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 5000);      
    }
  }
  catchFile(event) {  
    this.show = false;
    if(event.image1 != "" && event.file !=""){
      this.profileImageUpload = event.image1;
      this.imageUpload=  event.file;
      this.show = false;
      this.form.patchValue({
        profileImage:this.imageUpload
      })
      this.api.loader(false) 
    }  
  }   
  onFileUploaded(rawImage, fileName) { 
    this.show = false;
    // this.profileImage = rawImage;
    this.imageUpload = fileName;
    this.form.patchValue({
      profileImage:this.imageUpload
    })
  }
   
  onChangeDetected(event) {
  }
  close(){
    this.api.loader(false)
    this.show = false;
  } 
 // get current location
 getLocation1() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position: any) => {
      if (position) {
        this.form.value.latitude = position.coords.latitude;
        this.form.value.longitude = position.coords.longitude; 
      }
      this.modalService.hide(); 
    },
      // (error: PositionError) => console.log(error)
      );
  } else {
    alert("Geolocation is not supported by this browser.");
  }
}
getLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position: any) => {
      if (position) {
        this.form.value.latitude = position.coords.latitude;
        this.form.value.longitude = position.coords.longitude;
        let url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + this.form.value.latitude + "," + this.form.value.longitude + "&key=AIzaSyCDi96O9BAjbJUHBC-DTtw4QNmo3ekxIgA";
        this.getJSON(url);
      }
      this.modalService.hide();
    },
      // (error: PositionError) => console.log(error)
    );
  } else {
    alert("Geolocation is not supported by this browser.");
  }
}
getJSON(data:any){
  this.http = new HttpClient(this.handler);
  this.http.get(data).subscribe((res:any) => {
    let zipCode:any;
    let cityName:any;
    for (let i = 0; i < res.results.length; i++){
      for (let j = 0; j < res.results[i].address_components.length; j++){
        if (res.results[i].address_components[j].types.includes("postal_code")) {
          zipCode = res.results[i].address_components[j].long_name;
        }
        if (res.results[i].address_components[j].types.includes("locality")) {
          cityName = res.results[i].address_components[j].long_name;
        }
      }
    }
    this.form.patchValue({
      address : res.results[0].formatted_address,
      city : cityName,
      latitude : res.results[0].geometry.location.lat.toString(),
      longitude : res.results[0].geometry.location.lng.toString(),
      zipCode : zipCode,
    })
  })
}
onAddressChange(address: any) {
  this.form.value.address = address.formatted_address;
  this.form.value.latitude = address.geometry.location.lat().toString();
  this.form.value.longitude = address.geometry.location.lng().toString();
  for (let i = 0; i < address.address_components.length; i++){
    for (let j = 0; j < address.address_components[i].types.length; j++){
      if (address.address_components[i].types[j] == "postal_code") {
        this.form.value.zipCode = address.address_components[i].long_name;
      }
      if (address.address_components[i].types[j] == "locality"){
        this.form.value.city = address.address_components[i].long_name;
      }
      this.form.patchValue({
        address : this.form.value.address,
        latitude : this.form.value.latitude.toString(),
        longitude : this.form.value.longitude.toString(),
        zipCode: this.form.value.zipCode,
        city : this.form.value.city
      })
    }
  }
}
//   
openModal(template: TemplateRef<any>) { 
  this.modalRef = this.modalService.show(
    template,
    Object.assign({},this.config, { class: "modal-md addModal centerAlign" })
  ); 
}
closeModal(){ 
 this.modalService.hide();
}
  // submit from
  onSubmit(){
    var t = "https://"; 
    var w = "www."; 
    if(this.form.value.linkedInLink != null){
      // var t = "https://www."; 
      // var w = "www."; 
      if(this.form.value.linkedInLink.toString() != "" && !this.form.value.linkedInLink.toString().startsWith(t)&& !this.form.value.linkedInLink.toString().startsWith(w)){
        this.form.patchValue({
          linkedInLink : t +this.form.value.linkedInLink
        })
      } else if(this.form.value.linkedInLink.toString() != "" && this.form.value.linkedInLink.toString().startsWith(w)){  
        this.form.patchValue({
          linkedInLink : "https://" +this.form.value.linkedInLink
        })
      }
    }
    if(this.form.value.websiteLink != null){
      if(this.form.value.websiteLink.toString() != "" && !this.form.value.websiteLink.toString().startsWith(t)&& !this.form.value.websiteLink.toString().startsWith(w)){
        this.form.patchValue({
          websiteLink : t +this.form.value.websiteLink
        })
      } else if(this.form.value.websiteLink.toString() != "" && this.form.value.websiteLink.toString().startsWith(w)){  
        this.form.patchValue({
          websiteLink : "https://" +this.form.value.websiteLink
        })
      }
    }
    if(this.form.value.subscribeHonorvet == true ){
      this.form.value.subscribeHonorvet =1
    } else {
      this.form.value.subscribeHonorvet =0
    }
    if(this.form.value.phoneNumber !=""){
      this.form.value.countryCode= "+1"; 
    }
    if(this.form.valid){ 
      this.api.putData(apiUrl._recUpdateProfile, this.removeEmptyFiled(this.form))
      .subscribe(async (res) => {
        this.loading = false 
        this.showDiv=false;
        this.showEmail=true;
        setTimeout(() => {
          this.router.navigate(["/subscription"]);
        }, 3000);
      })
    } else{
      this.showError=true;
      // this.showErrorImage=true;
      setTimeout(() => {
        this.showError=false;
        this.showErrorImage=false;
      }, 3000);
    }
  }
  // check if only number
  preventNumbers(event): boolean { 
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }

    return formValues
  }
}